import RawMaterialsList from "../admin/RawMaterialsList";
// import BranchesPage from "../admin/BranchesPage";
import UserListPage from "../admin/UserListPage";
import Dashboard from "../admin/Dashboard";
import ProductList from "../admin/ProductList";
import InventoryPage from "../admin/InventoryPage";
import ProductPriceLogsPage from "../admin/ProductPriceLogsPage";
import AdminCalendarPage from "../admin/CalendarPage";
import UnderConstructionPage from "../components/CommonComponents/UnderConstructionIcon";
import Analytics from "../admin/Analytics";
import ProtectedRoute from "./ProtectedRoute";
import MainLayout from "../components/CommonComponents/MainLayout";
import TransactionList from "../components/transaction/TransactionList";
import Reports from "../admin/Reports";
import ProductionLogsPage from "../components/pos/pages/ProductionLogsPage";
import WasteLogsPage from "../admin/WasteLogsPage";
import RawMaterialLogsPage from "../admin/RawMaterialLogsPage";
import UserManualPage from "../admin/UserManualPage";
// import RecipesPage from "../admin/RecipesPage"; // Disabled: Ingredients feature

// import PreReleaseTracker from "../admin/PreReleaseTracker"; // Disabled: Pre-release tracker feature

export const adminRoutes = [
    {
        path: "/admin/raw-materials",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><RawMaterialsList /></MainLayout></ProtectedRoute>,
    },
    // Branches route moved to superadmin
    {
        path: "/admin/user-list",
        element: <ProtectedRoute allowedRoles={[1]} disallowManager><MainLayout><UserListPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/dashboard",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><Dashboard /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/transactions",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><TransactionList /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/waste-logs",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><WasteLogsPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/raw-material-logs",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><RawMaterialLogsPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/production-logs",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><ProductionLogsPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/user-manual",
        element: <ProtectedRoute allowedRoles={[1]}><UserManualPage /></ProtectedRoute>,
    },
    {
        path: "/admin/products",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><ProductList /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/product-price-logs",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><ProductPriceLogsPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/inventory",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><InventoryPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/calendar",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><AdminCalendarPage /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/analytics",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><Analytics /></MainLayout></ProtectedRoute>,
    },
    // {
    //     path: "/admin/pre-release-tracker",
    //     element: <ProtectedRoute allowedRoles={[1]} disallowManager><MainLayout><PreReleaseTracker /></MainLayout></ProtectedRoute>,
    // }, // Disabled: Pre-release tracker feature
    // {
    //     path: "/admin/recipes",
    //     element: <ProtectedRoute allowedRoles={[1]}><MainLayout><RecipesPage /></MainLayout></ProtectedRoute>,
    // }, // Disabled: Ingredients feature
    {
        path: "/admin/reports",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><Reports /></MainLayout></ProtectedRoute>,
    },
    {
        path: "/admin/settings",
        element: <ProtectedRoute allowedRoles={[1]}><MainLayout><UnderConstructionPage /></MainLayout></ProtectedRoute>,
    },
];
